<!-------------Mid Start----------------->

<!-- Please don’t change these IDs because those are for automated testing:- loginUserEmailInput, loginUserPwdInput, loginRmInput, loginFPLink, loginSubmitBtn, forgotPwdEmailInput, forgotPasswordSubmitBtn, forgotPasswordBackBtn, updatePasswordOtpInput, updatePasswordPwdInput, updatePasswordCPwdInput, updatePasswordBackBtn, updatePasswordUpdateBtn, generateLinkTabNoBtn and generateLinkTabYesBtn -->

@if (!isLogin && !isVerifyingEmail) {
  <div class="mid_container no-padding">
    <div class="sm_container">
      <div class="login__page">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 ">
            <div class="login__left login__bg__left">
              <div class="login__logo"><img src="/assets/images/svg_icons/login-logo.svg" alt="Login Logo" /></div>
              <p>{{ translations.GLOBAL.KEYS.SIGN_IN_WELCOME_TEXT_ONE | translate }}</p>
              <p class="text-no-margin-top">{{ translations.GLOBAL.KEYS.SIGN_IN_WELCOME_TEXT_TWO | translate }}</p>
              <div class="app__store__btns">
                <div class="appsstore__btn playstore">
                  <a href="https://play.google.com/store/search?q=wellbux&c=apps" target="_blank"> <img src="/assets/images/google-play-store.png" alt="" /> </a>
                </div>
                <div class="appsstore__btn appstore">
                  <a href="https://apps.apple.com/in/app/wellbux/id1580335328" tabindex="0" target="_blank"> <img src="/assets/images/app-store.png" alt="" /> </a>
                </div>
              </div>
            </div>
          </div>
          @if (!sAttributeData.isFP && !sAttributeData.isOTP) {
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="login__right">
                <h2> {{ translations.GLOBAL.KEYS.SIGN_IN | translate }}</h2>
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit(generateLinkTab)">
                  <div class="form">
                    <div class="login__input">
                      <input type="text" formControlName="username" id="loginUserEmailInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.ENTER_EMAIL)" />
                      @if (username.invalid && (username.touched || submitted )) {
                        <div  class="custom_error">
                          {{getCustomErrorMessage(username, getTranslation(translations.GLOBAL.KEYS.EMAIL))}}
                        </div>
                      }
                    </div>
                    <div class="login__input">
                      <input type="password" formControlName="password" id="loginUserPwdInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.ENTER_PASSWORD)" />
                      @if (password.invalid && (password.dirty || submitted )) {
                        <div  class="custom_error">
                          <!-- {{getCustomErrorMessage(password, getTranslation(translations.GLOBAL.KEYS.PASSWORD), {minLength:6})}} -->
                          {{getCustomErrorMessage(password, getTranslation(translations.GLOBAL.KEYS.PASSWORD) )}}
                        </div>
                      }
                    </div>
                    <div class="remember form-check">
                      <div class="remember-me" id="loginRmInput">
                        <input type="checkbox" name="checkboxG1" id="checkboxG1" class="css-checkbox" checked>
                        <label for="checkboxG1" class="css-label">{{ translations.GLOBAL.KEYS.REMEMBER_ME | translate }}</label>
                      </div>
                      <a id="loginFPLink" href="javascript:void(0)" (click)="sAttributeData.isFP = true">{{ translations.GLOBAL.KEYS.FORGOT_PASSWORD | translate }}?</a>
                      <div class="clear"></div>
                    </div>
                    <div class="login__submit">
                      <button id="loginSubmitBtn">{{ translations.GLOBAL.KEYS.SIGN_IN | translate }}</button>
                    </div>
                    <p class="btm_txt">{{ translations.GLOBAL.KEYS.DONT_HAVE_AN_ACCOUNT | translate }}? <a id="loginSignupLink" href="javascript:void(0)" routerLink="/signup">{{ translations.GLOBAL.KEYS.SIGN_UP | translate }}</a></p>
                    @if (showVerificationMessage) {
                      <div class="account-not-validated-txt btm_txt">
                        <p class="verification-message">Account not verified. <a id="resendVerificationLink" href="javascript:void(0)" (click)="resendVerificationEmail()">Resend Verification Email</a></p>
                      </div>
                    }
                  </div>
                </form>
              </div>
            </div>
          }
          @if (sAttributeData.isFP) {
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="login__right">
                <h2>{{ translations.GLOBAL.KEYS.FORGOT_PASSWORD | translate }}</h2>
                <form [formGroup]="ForgotPassword" (ngSubmit)="forgotPassword()">
                  <div class="form">
                    <div class="login__input">
                      <input type="text" formControlName="email" id="forgotPwdEmailInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.ENTER_EMAIL)" />
                      @if (email.invalid && (email.dirty || submitted )) {
                        <div class="custom_error">
                          {{getCustomErrorMessage(email, getTranslation(translations.GLOBAL.KEYS.EMAIL))}}
                        </div>
                      }
                    </div>
                    <div class="login__submit forgot__submit">
                      <button id="forgotPasswordBackBtn" class="btn_back" (click)="sAttributeData.isFP = false">{{ translations.GLOBAL.KEYS.BACK | translate }}</button>
                      <button id="forgotPasswordSubmitBtn" (click)="resetUpdatePasswordForm()">{{ translations.GLOBAL.KEYS.FORGOT_PASSWORD | translate }}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
          @if (sAttributeData.isOTP) {
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="login__right">
                <h2>{{ translations.GLOBAL.KEYS.UPDATE_PASSWORD | translate }}</h2>
                <form [formGroup]="ResetPassword" (ngSubmit)="updatePassword()">
                  <div class="form">
                    <div class="login__input">
                      <input id="updatePasswordOtpInput" type="text" formControlName="otp" [placeholder]="getTranslation(translations.GLOBAL.KEYS.ENTER_OTP)" />
                      @if (otp.invalid && (otp.dirty || submitted )) {
                        <div  class="custom_error">
                          {{getCustomErrorMessage(otp, getTranslation(translations.GLOBAL.KEYS.OTP))}}
                        </div>
                      }
                    </div>
                    <div class="login__input">
                      <input id="updatePasswordPwdInput" type="password" formControlName="password" [placeholder]="getTranslation(translations.GLOBAL.KEYS.PASSWORD)" autocomplete="new-password"/>
                      @if (resetPassword?.invalid && (resetPassword?.dirty || submitted)) {
                        <div class="custom_error">
                          @if (resetPassword.errors?.minLength) {
                            <div>{{ resetPassword.errors.minLength }}</div>
                          }
                          @if (resetPassword.errors?.uppercase) {
                            <div>{{ resetPassword.errors.uppercase }}</div>
                          }
                          @if (resetPassword.errors?.lowercase) {
                            <div>{{ resetPassword.errors.lowercase }}</div>
                          }
                          @if (resetPassword.errors?.number) {
                            <div>{{ resetPassword.errors.number }}</div>
                          }
                          @if (resetPassword.errors?.specialChar) {
                            <div>{{ resetPassword.errors.specialChar }}</div>
                          }
                          @if (resetPassword.errors?.noSpaces ) {
                            <div>{{ resetPassword.errors.noSpaces  }}</div>
                          }
                        </div>
                      }
                    </div>
                    <div class="login__input">
                      <input type="password" id="updatePasswordCPwdInput"  formControlName="confirmPassword" [placeholder]="getTranslation(translations.GLOBAL.KEYS.CONFIRM_PASSWORD)" />
                      @if (confirmPassword.invalid && (confirmPassword.dirty || submitted )) {
                        <div class="custom_error">
                          {{getCustomErrorMessage(confirmPassword, getTranslation(translations.GLOBAL.KEYS.CONFIRM_PASSWORD))}}
                          @if (confirmPassword.errors.mustMatch) {
                            <div>    {{
                              translations.GLOBAL.VALIDATION_MESSAGES.PASSWORD_NOT_MATCHED |
                              translate : { 'name': translations.GLOBAL.KEYS.PASSWORD | translate }
                              }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <div class="login__submit forgot__submit">
                      <button id="updatePasswordBackBtn" class="btn_back" (click)="sAttributeData.isFP = true; sAttributeData.isOTP = false">{{ translations.GLOBAL.KEYS.BACK | translate }}</button>
                      <button id="updatePasswordUpdateBtn">{{ translations.GLOBAL.KEYS.UPDATE_PASSWORD | translate }}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
<!-------------Mid End----------------->

<ng-template #generateLinkTab>
  <div>
    <div class="generateVerificationLinkTab">
      <div>
        {{ translations.GLOBAL.KEYS.GENERATE_VERIFICATION_LINK | translate }}
      </div>
      <div>
        <button id="generateLinkTabNoBtn" class="gray-btn_outline" (click)="bsModalRef.hide()" data-dismiss="modal">{{ translations.GLOBAL.KEYS.NO | translate }}</button> &nbsp;
        <button  id="generateLinkTabYesBtn" class="orange-btn_outline" (click)="generateVerificationLink()" data-dismiss="modal">{{ translations.GLOBAL.KEYS.YES | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>